import React, { useEffect, useMemo, useState } from "react";

const API_BASE = "https://panel.haymestasarim.com/api";

function tokenHeader() {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

function getLang() {
  const raw =
    localStorage.getItem("panel_dili") ||
    localStorage.getItem("app_lang") ||
    localStorage.getItem("lang") ||
    "tr";

  const l = String(raw).slice(0, 2).toLowerCase();
  return ["tr", "en", "de"].includes(l) ? l : "tr";
}

const TEXT = {
  tr: {
    pageTitle: "Mesaj Merkezi",
    pageSubtitle:
      "WhatsApp ve e-mail ile tekil veya toplu mesaj gönderin, kurumsal şablonlar oluşturun ve gönderim geçmişini takip edin.",
    newTemplate: "Yeni Şablon",
    templateTitle: "Şablon Başlığı",
    channel: "Kanal",
    source: "Kaynak",
    subject: "E-Mail Konusu",
    messageBody: "Mesaj Metni",
    saveTemplate: "Şablonu Kaydet",
    prepareMessage: "Mesaj Hazırla",
    selectTemplate: "Şablon Seç",
    noTemplate: "Şablonsuz / Manuel Mesaj",
    date: "Tarih",
    time: "Saat",
    customers: "Müşteriler",
    searchCustomer: "Müşteri ara...",
    selectAll: "Tümünü Seç",
    clear: "Temizle",
    selected: "Seçili",
    prepare: "Mesajları Hazırla",
    preparedMessages: "Hazırlanan Mesajlar",
    sendOpen: "Gönder / Aç",
    templates: "Şablonlar",
    delete: "Sil",
    logs: "Mesaj Geçmişi",
    customer: "Müşteri",
    phoneEmail: "Telefon / E-Mail",
    status: "Durum",
    sentDate: "Tarih",
    emptyCustomer: "Müşteri bulunamadı.",
    emptyPrepared: "Henüz hazırlanmış mesaj yok.",
    emptyTemplate: "Henüz şablon yok.",
    emptyLog: "Henüz mesaj geçmişi yok.",
    requiredTemplate: "Şablon başlığı ve mesaj metni zorunlu.",
    requiredCustomer: "En az bir müşteri seçmelisin.",
    requiredMessage: "Mesaj metni boş olamaz.",
    noContact: "Bu müşteri için uygun telefon veya e-mail yok.",
    confirmDelete: "Silmek istediğine emin misin?",
    copied: "Mesaj kopyalandı.",
    copy: "Kopyala",
    whatsapp: "WhatsApp",
    email: "E-Mail",
    beauty: "Beauty",
    manual: "Manuel",
    variables: "Kullanılabilir Alanlar",
    preview: "Önizleme",
    quickTemplates: "Hazır Kurumsal Şablonlar",
    birthday: "Doğum Günü",
    appointment: "Randevu Hatırlatma",
    holiday: "Bayram / Özel Gün",
    friday: "Hayırlı Cumalar",
    campaign: "Kampanya",
  },
  en: {
    pageTitle: "Message Center",
    pageSubtitle:
      "Send single or bulk messages via WhatsApp and e-mail, create corporate templates and track message history.",
    newTemplate: "New Template",
    templateTitle: "Template Title",
    channel: "Channel",
    source: "Source",
    subject: "E-Mail Subject",
    messageBody: "Message Body",
    saveTemplate: "Save Template",
    prepareMessage: "Prepare Message",
    selectTemplate: "Select Template",
    noTemplate: "No Template / Manual Message",
    date: "Date",
    time: "Time",
    customers: "Customers",
    searchCustomer: "Search customer...",
    selectAll: "Select All",
    clear: "Clear",
    selected: "Selected",
    prepare: "Prepare Messages",
    preparedMessages: "Prepared Messages",
    sendOpen: "Send / Open",
    templates: "Templates",
    delete: "Delete",
    logs: "Message History",
    customer: "Customer",
    phoneEmail: "Phone / E-Mail",
    status: "Status",
    sentDate: "Date",
    emptyCustomer: "No customer found.",
    emptyPrepared: "No prepared messages yet.",
    emptyTemplate: "No template yet.",
    emptyLog: "No message history yet.",
    requiredTemplate: "Template title and message body are required.",
    requiredCustomer: "You must select at least one customer.",
    requiredMessage: "Message body cannot be empty.",
    noContact: "No suitable phone or e-mail found for this customer.",
    confirmDelete: "Are you sure you want to delete?",
    copied: "Message copied.",
    copy: "Copy",
    whatsapp: "WhatsApp",
    email: "E-Mail",
    beauty: "Beauty",
    manual: "Manual",
    variables: "Available Variables",
    preview: "Preview",
    quickTemplates: "Ready Corporate Templates",
    birthday: "Birthday",
    appointment: "Appointment Reminder",
    holiday: "Holiday / Special Day",
    friday: "Friday Greeting",
    campaign: "Campaign",
  },
  de: {
    pageTitle: "Nachrichtenzentrale",
    pageSubtitle:
      "Senden Sie Einzel- oder Sammelnachrichten per WhatsApp und E-Mail, erstellen Sie Vorlagen und verfolgen Sie den Nachrichtenverlauf.",
    newTemplate: "Neue Vorlage",
    templateTitle: "Vorlagentitel",
    channel: "Kanal",
    source: "Quelle",
    subject: "E-Mail Betreff",
    messageBody: "Nachrichtentext",
    saveTemplate: "Vorlage speichern",
    prepareMessage: "Nachricht vorbereiten",
    selectTemplate: "Vorlage auswählen",
    noTemplate: "Ohne Vorlage / Manuell",
    date: "Datum",
    time: "Uhrzeit",
    customers: "Kunden",
    searchCustomer: "Kunde suchen...",
    selectAll: "Alle auswählen",
    clear: "Leeren",
    selected: "Ausgewählt",
    prepare: "Nachrichten vorbereiten",
    preparedMessages: "Vorbereitete Nachrichten",
    sendOpen: "Senden / Öffnen",
    templates: "Vorlagen",
    delete: "Löschen",
    logs: "Nachrichtenverlauf",
    customer: "Kunde",
    phoneEmail: "Telefon / E-Mail",
    status: "Status",
    sentDate: "Datum",
    emptyCustomer: "Kein Kunde gefunden.",
    emptyPrepared: "Noch keine vorbereiteten Nachrichten.",
    emptyTemplate: "Noch keine Vorlage.",
    emptyLog: "Noch kein Nachrichtenverlauf.",
    requiredTemplate: "Vorlagentitel und Nachrichtentext sind erforderlich.",
    requiredCustomer: "Mindestens ein Kunde muss ausgewählt werden.",
    requiredMessage: "Nachrichtentext darf nicht leer sein.",
    noContact: "Für diesen Kunden wurde keine passende Telefonnummer oder E-Mail gefunden.",
    confirmDelete: "Möchten Sie wirklich löschen?",
    copied: "Nachricht kopiert.",
    copy: "Kopieren",
    whatsapp: "WhatsApp",
    email: "E-Mail",
    beauty: "Beauty",
    manual: "Manuell",
    variables: "Verfügbare Variablen",
    preview: "Vorschau",
    quickTemplates: "Fertige Unternehmensvorlagen",
    birthday: "Geburtstag",
    appointment: "Terminerinnerung",
    holiday: "Feiertag / Besonderer Tag",
    friday: "Freitagsgruß",
    campaign: "Kampagne",
  },
};

const QUICK_TEMPLATES = {
  tr: {
    appointment:
      "Sayın {musteri_adi},\n\n{tarih} tarihinde saat {saat} randevunuz bulunmaktadır.\n\nKatılamayacaksanız lütfen bize bilgi veriniz.\n\n{firma_adi}",
    birthday:
      "Sayın {musteri_adi},\n\nDoğum gününüzü kutlar, sağlıklı ve mutlu bir yaş dileriz.\n\n{firma_adi}",
    holiday:
      "Sayın {musteri_adi},\n\nBayramınızı kutlar; sağlık, huzur ve mutluluk dileriz.\n\n{firma_adi}",
    friday:
      "Sayın {musteri_adi},\n\nHayırlı cumalar dileriz.\n\n{firma_adi}",
    campaign:
      "Sayın {musteri_adi},\n\nSize özel kampanyamız hakkında bilgi almak için bizimle iletişime geçebilirsiniz.\n\n{firma_adi}",
  },
  en: {
    appointment:
      "Dear {musteri_adi},\n\nYou have an appointment on {tarih} at {saat}.\n\nPlease inform us if you cannot attend.\n\n{firma_adi}",
    birthday:
      "Dear {musteri_adi},\n\nHappy birthday. We wish you a healthy and happy year.\n\n{firma_adi}",
    holiday:
      "Dear {musteri_adi},\n\nWe wish you a peaceful and happy holiday.\n\n{firma_adi}",
    friday:
      "Dear {musteri_adi},\n\nWe wish you a blessed Friday.\n\n{firma_adi}",
    campaign:
      "Dear {musteri_adi},\n\nYou can contact us to learn more about our special campaign.\n\n{firma_adi}",
  },
  de: {
    appointment:
      "Sehr geehrte/r {musteri_adi},\n\nSie haben am {tarih} um {saat} einen Termin.\n\nBitte informieren Sie uns, falls Sie nicht kommen können.\n\n{firma_adi}",
    birthday:
      "Sehr geehrte/r {musteri_adi},\n\nWir gratulieren Ihnen herzlich zum Geburtstag und wünschen Ihnen ein gesundes neues Lebensjahr.\n\n{firma_adi}",
    holiday:
      "Sehr geehrte/r {musteri_adi},\n\nWir wünschen Ihnen schöne und friedliche Feiertage.\n\n{firma_adi}",
    friday:
      "Sehr geehrte/r {musteri_adi},\n\nWir wünschen Ihnen einen gesegneten Freitag.\n\n{firma_adi}",
    campaign:
      "Sehr geehrte/r {musteri_adi},\n\nKontaktieren Sie uns gerne, um mehr über unsere aktuelle Aktion zu erfahren.\n\n{firma_adi}",
  },
};

const emptyTemplate = {
  title: "",
  channel: "whatsapp",
  source_module: "beaty",
  subject: "",
  body: "",
  whatsapp_template_name: "",
  whatsapp_template_lang: "tr",
  aktif: true,
};

function getDefaultBody(lang) {
  return QUICK_TEMPLATES[lang]?.appointment || QUICK_TEMPLATES.tr.appointment;
}

export default function MessageCenter() {
  const [lang, setLang] = useState(getLang());
  const TT = TEXT[lang] || TEXT.tr;

  const [templates, setTemplates] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [logs, setLogs] = useState([]);

  const [templateForm, setTemplateForm] = useState(emptyTemplate);
  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);

  const [channel, setChannel] = useState("whatsapp");
  const [sourceModule, setSourceModule] = useState("beaty");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [customSubject, setCustomSubject] = useState("");
  const [customBody, setCustomBody] = useState(getDefaultBody(getLang()));
  const [prepared, setPrepared] = useState([]);
  const [loading, setLoading] = useState(false);
const [customerSearch, setCustomerSearch] = useState("");
const [messagePurpose, setMessagePurpose] = useState("appointment");
const [activeView, setActiveView] = useState("compose");

const [settings, setSettings] = useState({
  sender_name: "",
  default_channel: "whatsapp",
  whatsapp_country_code: "90",
  appointment_reminder_active: false,
  appointment_reminder_days: "1",
  appointment_reminder_channel: "whatsapp",
  appointment_reminder_template_id: "",
  appointment_reminder_time: "09:00",
 birthday_message_active: false,
birthday_message_channel: "whatsapp",
birthday_message_template_id: "",
birthday_message_time: "09:00",

friday_message_active: false,
friday_message_channel: "whatsapp",
friday_message_template_id: "",
friday_message_time: "09:00",

whatsapp_api_active: false,
  whatsapp_phone_number: "",
  whatsapp_display_phone_number: "",
  whatsapp_phone_number_id: "",
  whatsapp_business_account_id: "",
  whatsapp_access_token: "",
  whatsapp_token_saved: false,
  whatsapp_api_provider: "meta",
  whatsapp_connected_at: "",
  whatsapp_status_message: "",
});


  const selectedTemplate = useMemo(
    () => templates.find((t) => String(t.id) === String(selectedTemplateId)),
    [templates, selectedTemplateId]
  );

const whatsappReady =
  settings.whatsapp_api_active === true &&
  !!settings.whatsapp_phone_number_id &&
  settings.whatsapp_token_saved === true;
const selectedCount = selectedCustomerIds.length;
  const filteredCustomers = useMemo(() => {
    const q = customerSearch.trim().toLowerCase();

    if (!q) return customers;

    return customers.filter((c) =>
     [
  c.customer_name,
  c.phone,
  c.email,
  c.gender,
  c.source_module,
  c.birth_date,
  c.appointment_date,
  c.appointment_time,
]
        .join(" ")
        .toLowerCase()
        .includes(q)
    );
  }, [customers, customerSearch]);

  const firstPreviewCustomer = useMemo(() => {
    return (
      customers.find((c) => selectedCustomerIds.includes(c.id)) ||
      customers[0] || {
        customer_name: "MESUT YILDIZ",
        phone: "05xxxxxxxxx",
        email: "mail@example.com",
      }
    );
  }, [customers, selectedCustomerIds]);

  const localPreview = useMemo(() => {
    return String(customBody || "")
      .replaceAll("{musteri_adi}", firstPreviewCustomer.customer_name || "")
      .replaceAll("{telefon}", firstPreviewCustomer.phone || "")
      .replaceAll("{email}", firstPreviewCustomer.email || "")
      .replaceAll("{firma_adi}", localStorage.getItem("app_institution_name") || "")
 

.replaceAll(
  "{tarih}",
  messagePurpose === "birthday"
    ? firstPreviewCustomer.birth_date
      ? String(firstPreviewCustomer.birth_date).slice(0, 10)
      : date || ""
    : firstPreviewCustomer.appointment_date
    ? String(firstPreviewCustomer.appointment_date).slice(0, 10)
    : date || ""
)
.replaceAll(
  "{saat}",
  messagePurpose === "birthday"
    ? ""
    : firstPreviewCustomer.appointment_time || time || ""
);

}, [customBody, firstPreviewCustomer, date, time, messagePurpose]);
  useEffect(() => {
    loadAll();

    const syncLang = () => {
      const l = getLang();
      setLang(l);
    };

    window.addEventListener("app_lang_change", syncLang);
    window.addEventListener("storage", syncLang);

    return () => {
      window.removeEventListener("app_lang_change", syncLang);
      window.removeEventListener("storage", syncLang);
    };
  }, []);

  useEffect(() => {
    if (selectedTemplate) {
      setChannel(selectedTemplate.channel || "whatsapp");
      setSourceModule(selectedTemplate.source_module || "beaty");
      setCustomSubject(selectedTemplate.subject || "");
      setCustomBody(selectedTemplate.body || "");
    }
  }, [selectedTemplate]);


const loadAll = async () => {
  setLoading(true);

  try {

const [templateRes, customerRes, logRes, settingsRes] = await Promise.all([
      // 📩 mesaj şablonları
      fetch(`${API_BASE}/messages/templates`, {
        headers: tokenHeader(),
      }),


      // 💇 BEAUTY MÜŞTERİLERİ
      // kurum_id token üzerinden backend çözer
   fetch(`${API_BASE}/messages/customers?source=beaty`, {
  headers: tokenHeader(),
}),


      // mesaj geçmişi
   fetch(`${API_BASE}/messages/logs`, {
  headers: tokenHeader(),
}),

fetch(`${API_BASE}/messages/settings`, {
  headers: tokenHeader(),
}),

    ]);


    const templateJson =
      await templateRes.json().catch(() => ({}));

    const customerJson =
      await customerRes.json().catch(() => ({}));

    const logJson =
      await logRes.json().catch(() => ({}));

const settingsJson =
  await settingsRes.json().catch(() => ({}));


    setTemplates(templateJson.data || []);


    // KasaPanel ile aynı format
 setCustomers(
  (customerJson.data || []).map((c) => ({
    id: c.id,
    customer_name: c.customer_name || c.full_name,
    phone: c.phone,
    email: c.email,
    birth_date: c.birth_date,
    appointment_date: c.appointment_date,
   appointment_time: c.appointment_time,
packages: c.packages || [],
source_module: "beaty",
  }))
);


    setLogs(logJson.data || []);

if (settingsJson.data) {
  setSettings({
    sender_name: settingsJson.data.sender_name || "",
    default_channel: settingsJson.data.default_channel || "whatsapp",
    whatsapp_country_code: settingsJson.data.whatsapp_country_code || "90",
    appointment_reminder_active:
      settingsJson.data.appointment_reminder_active === true,
appointment_reminder_days:
      settingsJson.data.appointment_reminder_days || "1",
send_start_time:
      settingsJson.data.send_start_time || "09:00",
send_end_time:
      settingsJson.data.send_end_time || "18:00",
    appointment_reminder_channel:
      settingsJson.data.appointment_reminder_channel || "whatsapp",
    appointment_reminder_template_id:
      settingsJson.data.appointment_reminder_template_id || "",
    appointment_reminder_time:
      settingsJson.data.appointment_reminder_time || "09:00",
birthday_message_active:
  settingsJson.data.birthday_message_active === true,
birthday_message_channel:
  settingsJson.data.birthday_message_channel || "whatsapp",
birthday_message_template_id:
  settingsJson.data.birthday_message_template_id || "",
birthday_message_time:
  settingsJson.data.birthday_message_time || "09:00",

friday_message_active:
  settingsJson.data.friday_message_active === true,
friday_message_channel:
  settingsJson.data.friday_message_channel || "whatsapp",
friday_message_template_id:
  settingsJson.data.friday_message_template_id || "",
friday_message_time:
  settingsJson.data.friday_message_time || "09:00",

whatsapp_api_active:
  settingsJson.data.whatsapp_api_active === true,
whatsapp_phone_number:
  settingsJson.data.whatsapp_phone_number || "",
whatsapp_display_phone_number:
  settingsJson.data.whatsapp_display_phone_number || "",
whatsapp_phone_number_id:
  settingsJson.data.whatsapp_phone_number_id || "",
whatsapp_business_account_id:
  settingsJson.data.whatsapp_business_account_id || "",
whatsapp_access_token: "",
whatsapp_token_saved:
  settingsJson.data.whatsapp_token_saved === true,
whatsapp_api_provider:
  settingsJson.data.whatsapp_api_provider || "meta",
whatsapp_connected_at:
  settingsJson.data.whatsapp_connected_at || "",
whatsapp_status_message:
  settingsJson.data.whatsapp_status_message || "",



  });
}
  } catch (err) {

    console.error(
      "MESSAGE CENTER LOAD ERROR:",
      err
    );

    alert("Mesaj merkezi yüklenemedi");

  } finally {

    setLoading(false);

  }
};
 const applyQuickTemplate = (key) => {
  setMessagePurpose(key);

  const body = QUICK_TEMPLATES[lang]?.[key] || QUICK_TEMPLATES.tr[key] || "";
  setCustomBody(body);

    if (key === "appointment") {
      setCustomSubject(
        lang === "de"
          ? "Terminerinnerung"
          : lang === "en"
          ? "Appointment Reminder"
          : "Randevu Hatırlatma"
      );
    }

    if (key === "birthday") {
      setCustomSubject(
        lang === "de"
          ? "Geburtstagsgruß"
          : lang === "en"
          ? "Birthday Greeting"
          : "Doğum Günü Mesajı"
      );
    }
  };

  const saveTemplate = async () => {
    if (!templateForm.title || !templateForm.body) {
      alert(TT.requiredTemplate);
      return;
    }

    const res = await fetch(`${API_BASE}/messages/templates`, {
      method: "POST",
      headers: tokenHeader(),
      body: JSON.stringify(templateForm),
    });

    const json = await res.json().catch(() => ({}));

    if (!res.ok || json.ok === false) {
      alert(json.message || "Şablon kaydedilemedi");
      return;
    }

    setTemplateForm(emptyTemplate);
    loadAll();
  };

  const deleteTemplate = async (id) => {
    if (!window.confirm(TT.confirmDelete)) return;

    const res = await fetch(`${API_BASE}/messages/templates/${id}`, {
      method: "DELETE",
      headers: tokenHeader(),
    });

    const json = await res.json().catch(() => ({}));

    if (!res.ok || json.ok === false) {
      alert(json.message || "Şablon silinemedi");
      return;
    }

    loadAll();
  };

  const toggleCustomer = (id) => {
    setSelectedCustomerIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const selectAllCustomers = () => {
    setSelectedCustomerIds(filteredCustomers.map((c) => c.id));
  };

  const clearCustomers = () => {
    setSelectedCustomerIds([]);
    setPrepared([]);
  };

  const prepareMessages = async () => {
    if (selectedCustomerIds.length === 0) {
      alert(TT.requiredCustomer);
      return;
    }

    if (!customBody.trim()) {
      alert(TT.requiredMessage);
      return;
    }

    const res = await fetch(`${API_BASE}/messages/prepare`, {
      method: "POST",
      headers: tokenHeader(),
      body: JSON.stringify({
        template_id: selectedTemplateId || null,
        customer_ids: selectedCustomerIds,
        source_module: sourceModule,
        channel,
        custom_subject: customSubject,
      custom_body: customBody,
message_purpose: messagePurpose,
date,
time,
      }),
    });

    const json = await res.json().catch(() => ({}));

    if (!res.ok || json.ok === false) {
alert(json.message || JSON.stringify(json) || "Mesaj hazırlanamadı");
  return;
    }

    setPrepared(json.data || []);
    setActiveView("prepared");
  };

  const logMessage = async (msg) => {
    await fetch(`${API_BASE}/messages/log`, {
      method: "POST",
      headers: tokenHeader(),
      body: JSON.stringify({
        template_id: selectedTemplateId || null,
        customer_id: msg.customer_id,
        customer_name: msg.customer_name,
        phone: msg.phone,
        email: msg.email,
        channel: msg.channel,
        source_module: sourceModule,
        subject: msg.subject,
        body: msg.body,
        status: "sent_manual",
      }),
    });

    loadAll();
  };

const sendViaWhatsappApi = async (msg) => {
  const res = await fetch(`${API_BASE}/messages/send`, {
    method: "POST",
    headers: tokenHeader(),
    body: JSON.stringify({
      template_id: selectedTemplateId || null,
      customer_id: msg.customer_id,
      customer_name: msg.customer_name,
      phone: msg.phone,
      email: msg.email,
      channel: msg.channel,
      source_module: sourceModule,
      subject: msg.subject,
      body: msg.body,
    }),
  });

  const json = await res.json().catch(() => ({}));

if (!res.ok || json.ok === false) {
  const errorMessage =
    json?.meta?.error?.message ||
    json?.meta?.error?.error_user_msg ||
    json?.message ||
    "WhatsApp API mesaj gönderemedi";

  alert(errorMessage);
  return false;
}

  alert("WhatsApp mesajı gönderildi");
  loadAll();
  return true;
};

const openAndLog = async (msg) => {
  // Şablon seçilmemişse WhatsApp API'ye gönderme.
  // Normal wa.me linkiyle aç.
  if (msg.channel === "whatsapp" && whatsappReady && selectedTemplateId) {
    await sendViaWhatsappApi(msg);
    return;
  }

  const url = msg.channel === "email" ? msg.mailto_url : msg.whatsapp_url;

  if (!url) {
    alert(TT.noContact);
    return;
  }

  window.open(url, "_blank");
  await logMessage(msg);
};


const saveSettings = async () => {
  const payload = {
    ...settings,
    whatsapp_access_token:
      settings.whatsapp_access_token &&
      String(settings.whatsapp_access_token).trim()
        ? settings.whatsapp_access_token
        : undefined,
  };

  const res = await fetch(`${API_BASE}/messages/settings`, {
    method: "PUT",
    headers: tokenHeader(),
    body: JSON.stringify(payload),
  });

  const json = await res.json().catch(() => ({}));

  if (!res.ok || json.ok === false) {
    alert(json.message || "Mesaj ayarları kaydedilemedi");
    return;
  }

  alert("Mesaj ayarları kaydedildi");
  loadAll();
};

const runAutomationNow = async () => {
  const res = await fetch(`${API_BASE}/messages/automation/run`, {
    method: "POST",
    headers: tokenHeader(),
    body: JSON.stringify({ force: true }),
  });

  const json = await res.json().catch(() => ({}));

  if (!res.ok || json.ok === false) {
    alert(json.message || "Otomatik mesaj çalıştırılamadı");
    return;
  }

  const summary = json.summary || {};
  const sent = Number(summary.sent || 0);
  const failed = Number(summary.failed || 0);
  const preparedCount = Number(summary.prepared || 0);
  const total = sent + failed + preparedCount;

  alert(
    `${json.message || "Otomatik mesaj kontrolü çalıştı"}\n` +
      `Başarılı: ${sent}\n` +
      `Başarısız: ${failed}\n` +
      `Hazırlandı: ${preparedCount}` +
      (total === 0
        ? "\n\nUygun tarihli kişi bulunamadı veya aktif bir Meta şablonu seçilmedi."
        : "")
  );

  loadAll();
};


const connectWhatsapp = async () => {
  const requestedPhone = String(
    settings.whatsapp_phone_number ||
      settings.whatsapp_display_phone_number ||
      ""
  ).trim();

  if (!requestedPhone) {
    alert(
      "Önce firmaya ait gerçek WhatsApp numarasını yaz. Örnek: +90 505 010 79 04"
    );
    return;
  }

  const savePayload = {
    ...settings,
    whatsapp_phone_number: requestedPhone,
    whatsapp_display_phone_number: requestedPhone,
    whatsapp_access_token:
      settings.whatsapp_access_token &&
      String(settings.whatsapp_access_token).trim()
        ? settings.whatsapp_access_token
        : undefined,
  };

  const saveRes = await fetch(
    `${API_BASE}/messages/settings`,
    {
      method: "PUT",
      headers: tokenHeader(),
      body: JSON.stringify(savePayload),
    }
  );

  const saveJson = await saveRes
    .json()
    .catch(() => ({}));

  if (!saveRes.ok || saveJson.ok === false) {
    alert(
      saveJson.message ||
        "Firma WhatsApp numarası kaydedilemedi"
    );
    return;
  }

  const params = new URLSearchParams({
    phone: requestedPhone,
    country_code: String(
      settings.whatsapp_country_code || "90"
    ),
  });

  const res = await fetch(
    `${API_BASE}/whatsapp/connect-url?${params.toString()}`,
    {
      headers: tokenHeader(),
    }
  );

  const json = await res.json().catch(() => ({}));

  if (!res.ok || json.ok === false || !json.url) {
    alert(
      json.message ||
        "WhatsApp bağlantı linki alınamadı"
    );
    return;
  }

  window.location.href = json.url;
};



  const copyText = async (txt) => {
    try {
      await navigator.clipboard.writeText(txt || "");
      alert(TT.copied);
    } catch {
      const textarea = document.createElement("textarea");
      textarea.value = txt || "";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      alert(TT.copied);
    }
  };

  if (loading) {
    return <div style={styles.loading}>{TT.loading || "Yükleniyor..."}</div>;
  }

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <div>
          <div style={styles.headerBadge}>MESYAT CRM</div>
          <h1 style={styles.title}>📩 {TT.pageTitle}</h1>
          <p style={styles.subtitle}>{TT.pageSubtitle}</p>
        </div>

        <div style={styles.headerStats}>
          <StatMini label={TT.customers} value={customers.length} />
          <StatMini label={TT.templates} value={templates.length} />
          <StatMini label={TT.logs} value={logs.length} />
        </div>
      </div>

      <div style={styles.tabs}>
        <button
          style={activeView === "compose" ? styles.tabActive : styles.tab}
          onClick={() => setActiveView("compose")}
        >
          {TT.prepareMessage}
        </button>
        <button
          style={activeView === "prepared" ? styles.tabActive : styles.tab}
          onClick={() => setActiveView("prepared")}
        >
          {TT.preparedMessages} ({prepared.length})
        </button>
        <button
          style={activeView === "templates" ? styles.tabActive : styles.tab}
          onClick={() => setActiveView("templates")}
        >
          {TT.templates}
        </button>
        <button
          style={activeView === "logs" ? styles.tabActive : styles.tab}
          onClick={() => setActiveView("logs")}
        >
          {TT.logs}
        </button>
<button
  style={activeView === "settings" ? styles.tabActive : styles.tab}
  onClick={() => setActiveView("settings")}
>
  Otomatik Ayarlar
</button>

      </div>

      {activeView === "compose" && (
        <>
          <div style={styles.grid}>
            <section style={styles.card}>
              <h2 style={styles.cardTitle}>{TT.prepareMessage}</h2>

              <Select
                label={TT.selectTemplate}
                value={selectedTemplateId}
                onChange={setSelectedTemplateId}
                options={[
                  { value: "", label: TT.noTemplate },
                  ...templates.map((t) => ({
                    value: t.id,
                    label: `${t.title} - ${t.channel}`,
                  })),
                ]}
              />

              <div style={styles.two}>
                <Select
                  label={TT.channel}
                  value={channel}
                  onChange={setChannel}
                  options={[
                    { value: "whatsapp", label: TT.whatsapp },
                    { value: "email", label: TT.email },
                  ]}
                />

                <Select
                  label={TT.source}
                  value={sourceModule}
                  onChange={setSourceModule}
                  options={[
                    { value: "beaty", label: TT.beauty },
                    { value: "general", label: TT.manual },
                  ]}
                />
              </div>

   <div style={styles.two}>
  <Input label={TT.date} type="date" value={date} onChange={setDate} />
  <Input label={TT.time} type="time" value={time} onChange={setTime} />
</div>

              <Input
                label={TT.subject}
                value={customSubject}
                onChange={setCustomSubject}
              />

              <Textarea
                label={TT.messageBody}
                value={customBody}
                onChange={setCustomBody}
              />

              <div style={styles.quickBox}>
                <b>{TT.quickTemplates}</b>
                <div style={styles.quickButtons}>
                  <button style={styles.quickBtn} onClick={() => applyQuickTemplate("appointment")}>
                    {TT.appointment}
                  </button>
                  <button style={styles.quickBtn} onClick={() => applyQuickTemplate("birthday")}>
                    {TT.birthday}
                  </button>
                  <button style={styles.quickBtn} onClick={() => applyQuickTemplate("holiday")}>
                    {TT.holiday}
                  </button>
                  <button style={styles.quickBtn} onClick={() => applyQuickTemplate("friday")}>
                    {TT.friday}
                  </button>
                  <button style={styles.quickBtn} onClick={() => applyQuickTemplate("campaign")}>
                    {TT.campaign}
                  </button>
                </div>
              </div>

              <div style={styles.helper}>
                <b>{TT.variables}:</b> {"{musteri_adi}"} {"{firma_adi}"} {"{tarih}"} {"{saat}"} {"{telefon}"} {"{email}"}
              </div>

              <button style={styles.primaryBtn} onClick={prepareMessages}>
                {TT.prepare} ({selectedCount})
              </button>
            </section>

            <section style={styles.card}>
              <h2 style={styles.cardTitle}>{TT.preview}</h2>

              <div style={styles.previewPhone}>
                <div style={styles.previewTop}>
                  <span>{channel === "email" ? TT.email : TT.whatsapp}</span>
                </div>

                {channel === "email" && (
                  <div style={styles.previewSubject}>
                    <b>{TT.subject}:</b> {customSubject || "-"}
                  </div>
                )}

                <pre style={styles.previewText}>{localPreview}</pre>
              </div>

              <button style={styles.secondaryFull} onClick={() => copyText(localPreview)}>
                {TT.copy}
              </button>
            </section>
          </div>

          <section style={styles.card}>
            <div style={styles.rowBetween}>
              <h2 style={styles.cardTitle}>{TT.customers}</h2>

              <div style={styles.actions}>
                <button style={styles.secondaryBtn} onClick={selectAllCustomers}>
                  {TT.selectAll}
                </button>
                <button style={styles.secondaryBtn} onClick={clearCustomers}>
                  {TT.clear}
                </button>
              </div>
            </div>

            <Input
              label={TT.searchCustomer}
              value={customerSearch}
              onChange={setCustomerSearch}
            />

            <div style={styles.selectedInfo}>
              {TT.selected}: <b>{selectedCount}</b>
            </div>

            {filteredCustomers.length === 0 ? (
              <div style={styles.empty}>{TT.emptyCustomer}</div>
            ) : (
              <div style={styles.customerGrid}>
                {filteredCustomers.map((c) => (
                  <label
                    key={c.id}
                    style={
                      selectedCustomerIds.includes(c.id)
                        ? styles.customerBoxActive
                        : styles.customerBox
                    }
                  >
                    <input
                      type="checkbox"
                      checked={selectedCustomerIds.includes(c.id)}
                      onChange={() => toggleCustomer(c.id)}
                    />
                    <div>
                      <b>{c.customer_name}</b>
                   <div style={styles.small}>
  Telefon: {c.phone || "-"} / E-Mail: {c.email || "-"}
</div>

<div style={styles.small}>
  Doğum Tarihi: {c.birth_date ? String(c.birth_date).slice(0, 10) : "-"}
</div>


{(c.packages || []).map((p, i) => (
  <div key={i} style={styles.small}>
    💆 {p.package_name || "Paket"} :
    {" "}
    {p.used_sessions || 0}/{p.total_sessions || 0}
    {" "}
    (Kalan: {p.remaining_sessions || 0})
    <br />
    Başlangıç: {p.package_start_date ? String(p.package_start_date).slice(0, 10) : "-"}
    {" / "}
    Bitiş: {p.package_end_date ? String(p.package_end_date).slice(0, 10) : "-"}
    <br />
    Sonraki Seans: {p.next_session_date ? String(p.next_session_date).slice(0, 10) : "-"}
  </div>
))}
                    </div>
                  </label>
                ))}
              </div>
            )}
          </section>
        </>
      )}

      {activeView === "prepared" && (
        <section style={styles.card}>
          <h2 style={styles.cardTitle}>{TT.preparedMessages}</h2>

          {prepared.length === 0 ? (
            <div style={styles.empty}>{TT.emptyPrepared}</div>
          ) : (
            <div style={styles.tableWrap}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th>{TT.customer}</th>
                    <th>{TT.channel}</th>
                    <th>{TT.messageBody}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {prepared.map((m) => (
                    <tr key={`${m.customer_id}-${m.channel}`}>
                      <td>
                        <b>{m.customer_name}</b>
                        <div style={styles.small}>{m.phone || m.email}</div>
                      </td>
                      <td>
                        <span style={m.channel === "email" ? styles.emailBadge : styles.whatsappBadge}>
                          {m.channel === "email" ? TT.email : TT.whatsapp}
                        </span>
                      </td>
                      <td style={styles.messageCell}>{m.body}</td>
                      <td>
                        <div style={styles.rowBtns}>
                          <button style={styles.copyBtn} onClick={() => copyText(m.body)}>
                            {TT.copy}
                          </button>
                          <button style={styles.sendBtn} onClick={() => openAndLog(m)}>
                            {TT.sendOpen}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>
      )}

      {activeView === "templates" && (
        <div style={styles.grid}>
          <section style={styles.card}>
            <h2 style={styles.cardTitle}>{TT.newTemplate}</h2>

            <Input
              label={TT.templateTitle}
              value={templateForm.title}
              onChange={(v) => setTemplateForm({ ...templateForm, title: v })}
            />

            <div style={styles.two}>
              <Select
                label={TT.channel}
                value={templateForm.channel}
                onChange={(v) => setTemplateForm({ ...templateForm, channel: v })}
                options={[
                  { value: "whatsapp", label: TT.whatsapp },
                  { value: "email", label: TT.email },
                ]}
              />

              <Select
                label={TT.source}
                value={templateForm.source_module}
                onChange={(v) =>
                  setTemplateForm({ ...templateForm, source_module: v })
                }
                options={[
                  { value: "beaty", label: TT.beauty },
                  { value: "general", label: TT.manual },
                ]}
              />
            </div>

            <Input
              label={TT.subject}
              value={templateForm.subject}
              onChange={(v) => setTemplateForm({ ...templateForm, subject: v })}
            />

            {templateForm.channel === "whatsapp" && (
              <>
                <div style={styles.two}>
                  <Input
                    label="Meta onaylı şablon adı"
                    value={templateForm.whatsapp_template_name}
                    onChange={(v) =>
                      setTemplateForm({
                        ...templateForm,
                        whatsapp_template_name: String(v || "")
                          .trim()
                          .toLowerCase()
                          .replace(/[^a-z0-9_]/g, "_"),
                      })
                    }
                  />

                  <Select
                    label="Meta şablon dili"
                    value={templateForm.whatsapp_template_lang || "tr"}
                    onChange={(v) =>
                      setTemplateForm({
                        ...templateForm,
                        whatsapp_template_lang: v,
                      })
                    }
                    options={[
                      { value: "tr", label: "Türkçe - tr" },
                      { value: "de", label: "Almanca - de" },
                      { value: "en_US", label: "İngilizce - en_US" },
                    ]}
                  />
                </div>

                <div style={styles.helper}>
                  Meta WhatsApp Manager içinde onaylanmış şablonun gerçek adını
                  aynen yazın. Bu alan otomatik randevu, doğum günü ve cuma
                  mesajlarında kullanılır.
                </div>
              </>
            )}

            <Textarea
              label={TT.messageBody}
              value={templateForm.body}
              onChange={(v) => setTemplateForm({ ...templateForm, body: v })}
            />

            <button style={styles.primaryBtn} onClick={saveTemplate}>
              {TT.saveTemplate}
            </button>
          </section>

          <section style={styles.card}>
            <h2 style={styles.cardTitle}>{TT.templates}</h2>

            {templates.length === 0 ? (
              <div style={styles.empty}>{TT.emptyTemplate}</div>
            ) : (
              <div style={styles.templateList}>
                {templates.map((t) => (
                  <div key={t.id} style={styles.templateItem}>
                    <div>
                      <b>{t.title}</b>
                      <div style={styles.small}>
                        {t.channel} / {t.source_module}
                      </div>
                      {t.channel === "whatsapp" && (
                        <div style={styles.small}>
                          Meta: {t.whatsapp_template_name || "Tanımlanmamış"} /{" "}
                          {t.whatsapp_template_lang || "tr"}
                        </div>
                      )}
                      <p style={styles.templatePreview}>{t.body}</p>
                    </div>

                    <button style={styles.deleteBtn} onClick={() => deleteTemplate(t.id)}>
                      {TT.delete}
                    </button>
                  </div>
                ))}
              </div>
            )}
          </section>
        </div>
      )}

      {activeView === "logs" && (
        <section style={styles.card}>
          <h2 style={styles.cardTitle}>{TT.logs}</h2>

          {logs.length === 0 ? (
            <div style={styles.empty}>{TT.emptyLog}</div>
          ) : (
            <div style={styles.tableWrap}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th>{TT.sentDate}</th>
                    <th>{TT.customer}</th>
                    <th>{TT.channel}</th>
                    <th>{TT.status}</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.slice(0, 200).map((l) => (
                    <tr key={l.id}>
                      <td>{String(l.sent_at || l.created_at || "").slice(0, 19)}</td>
                      <td>{l.customer_name || "-"}</td>
                      <td>{l.channel}</td>
                      <td>{l.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>
      )}

{activeView === "settings" && (
  <section style={styles.card}>
    <h2 style={styles.cardTitle}>Otomatik Mesaj Ayarları</h2>

    <div style={styles.helper}>
      Üç otomasyon birbirinden bağımsız çalışır: randevu hatırlatma, doğum günü
      ve cuma mesajı. Firma kendi Phone Number ID, WABA ID ve Access Token
      bilgilerini kaydeder. Backend panel kapalıyken de her 30 dakikada kontrol
      eder.
    </div>

    <h3 style={styles.sectionTitle}>1. Randevu Hatırlatma</h3>

    <label style={styles.customerBox}>
      <input
        type="checkbox"
        checked={settings.appointment_reminder_active === true}
        onChange={(e) =>
          setSettings({
            ...settings,
            appointment_reminder_active: e.target.checked,
          })
        }
      />
      <div>
        <b>Randevu hatırlatma aktif</b>
        <div style={styles.small}>
          Randevu veya sonraki seans tarihinden seçilen gün kadar önce otomatik
          mesaj gönderir.
        </div>
      </div>
    </label>

    <div style={styles.two}>
      <Select
        label="Randevudan kaç gün önce gönderilsin?"
        value={settings.appointment_reminder_days || "1"}
        onChange={(v) =>
          setSettings({
            ...settings,
            appointment_reminder_days: v,
          })
        }
        options={[
          { value: "1", label: "1 gün önce" },
          { value: "2", label: "2 gün önce" },
          { value: "3", label: "3 gün önce" },
          { value: "7", label: "1 hafta önce" },
        ]}
      />

      <Input
        label="Randevu gönderim saati"
        type="time"
        value={settings.appointment_reminder_time || "09:00"}
        onChange={(v) =>
          setSettings({
            ...settings,
            appointment_reminder_time: v,
          })
        }
      />
    </div>

    <div style={styles.two}>
      <Select
        label="Randevu gönderim kanalı"
        value={settings.appointment_reminder_channel || "whatsapp"}
        onChange={(v) =>
          setSettings({
            ...settings,
            appointment_reminder_channel: v,
          })
        }
        options={[
          { value: "whatsapp", label: "WhatsApp" },
          { value: "email", label: "E-Mail" },
        ]}
      />

      <Select
        label="Randevu hatırlatma şablonu"
        value={settings.appointment_reminder_template_id || ""}
        onChange={(v) =>
          setSettings({
            ...settings,
            appointment_reminder_template_id: v,
          })
        }
        options={[
          { value: "", label: "Şablon seç" },
          ...templates
            .filter((t) => t.channel === "whatsapp")
            .map((t) => ({
              value: t.id,
              label: `${t.title} - ${
                t.whatsapp_template_name || "Meta adı yok"
              }`,
            })),
        ]}
      />
    </div>

    <h3 style={styles.sectionTitle}>2. Doğum Günü Mesajı</h3>

    <label style={styles.customerBox}>
      <input
        type="checkbox"
        checked={settings.birthday_message_active === true}
        onChange={(e) =>
          setSettings({
            ...settings,
            birthday_message_active: e.target.checked,
          })
        }
      />
      <div>
        <b>Doğum günü mesajı aktif</b>
        <div style={styles.small}>
          Cari veya Beauty müşteri kartında doğum tarihi bulunan kişilere
          doğum gününde otomatik mesaj gönderir.
        </div>
      </div>
    </label>

    <div style={styles.two}>
      <Select
        label="Doğum günü kanalı"
        value={settings.birthday_message_channel || "whatsapp"}
        onChange={(v) =>
          setSettings({
            ...settings,
            birthday_message_channel: v,
          })
        }
        options={[
          { value: "whatsapp", label: "WhatsApp" },
          { value: "email", label: "E-Mail" },
        ]}
      />

      <Input
        label="Doğum günü gönderim saati"
        type="time"
        value={settings.birthday_message_time || "09:00"}
        onChange={(v) =>
          setSettings({
            ...settings,
            birthday_message_time: v,
          })
        }
      />
    </div>

    <Select
      label="Doğum günü şablonu"
      value={settings.birthday_message_template_id || ""}
      onChange={(v) =>
        setSettings({
          ...settings,
          birthday_message_template_id: v,
        })
      }
      options={[
        { value: "", label: "Şablon seç" },
        ...templates
          .filter((t) => t.channel === "whatsapp")
          .map((t) => ({
            value: t.id,
            label: `${t.title} - ${
              t.whatsapp_template_name || "Meta adı yok"
            }`,
          })),
      ]}
    />

    <h3 style={styles.sectionTitle}>3. Cuma Mesajı</h3>

    <label style={styles.customerBox}>
      <input
        type="checkbox"
        checked={settings.friday_message_active === true}
        onChange={(e) =>
          setSettings({
            ...settings,
            friday_message_active: e.target.checked,
          })
        }
      />
      <div>
        <b>Cuma mesajı aktif</b>
        <div style={styles.small}>
          Her cuma Cari ve Beauty müşteri havuzundaki telefonlara, aynı numarayı
          tekrar etmeden otomatik mesaj gönderir.
        </div>
      </div>
    </label>

    <div style={styles.two}>
      <Select
        label="Cuma mesajı kanalı"
        value={settings.friday_message_channel || "whatsapp"}
        onChange={(v) =>
          setSettings({
            ...settings,
            friday_message_channel: v,
          })
        }
        options={[
          { value: "whatsapp", label: "WhatsApp" },
          { value: "email", label: "E-Mail" },
        ]}
      />

      <Input
        label="Cuma mesajı gönderim saati"
        type="time"
        value={settings.friday_message_time || "09:00"}
        onChange={(v) =>
          setSettings({
            ...settings,
            friday_message_time: v,
          })
        }
      />
    </div>

    <Select
      label="Cuma mesajı şablonu"
      value={settings.friday_message_template_id || ""}
      onChange={(v) =>
        setSettings({
          ...settings,
          friday_message_template_id: v,
        })
      }
      options={[
        { value: "", label: "Şablon seç" },
        ...templates
          .filter((t) => t.channel === "whatsapp")
          .map((t) => ({
            value: t.id,
            label: `${t.title} - ${
              t.whatsapp_template_name || "Meta adı yok"
            }`,
          })),
      ]}
    />

    <h3 style={styles.sectionTitle}>Genel Gönderim Saat Aralığı</h3>

    <div style={styles.two}>
      <Input
        label="Başlangıç saati"
        type="time"
        value={settings.send_start_time || "09:00"}
        onChange={(v) =>
          setSettings({
            ...settings,
            send_start_time: v,
          })
        }
      />

      <Input
        label="Bitiş saati"
        type="time"
        value={settings.send_end_time || "18:00"}
        onChange={(v) =>
          setSettings({
            ...settings,
            send_end_time: v,
          })
        }
      />
    </div>

    <h3 style={styles.sectionTitle}>Firmaya Özel WhatsApp Business API</h3>

    <div style={styles.customerBox}>
      <div style={{ flex: 1 }}>
        <b>
          {whatsappReady
            ? "WhatsApp API bağlı"
            : "WhatsApp API bağlı değil veya eksik"}
        </b>

        <div style={styles.small}>
          Numara:{" "}
          {settings.whatsapp_display_phone_number ||
            settings.whatsapp_phone_number ||
            "-"}
        </div>

        <div style={styles.small}>
          Phone Number ID: {settings.whatsapp_phone_number_id || "-"}
        </div>

        <div style={styles.small}>
          WABA ID: {settings.whatsapp_business_account_id || "-"}
        </div>

        <div style={styles.small}>
          Token: {settings.whatsapp_token_saved ? "Kayıtlı" : "Yok"}
        </div>

        {settings.whatsapp_status_message && (
          <div style={styles.small}>
            Durum: {settings.whatsapp_status_message}
          </div>
        )}
      </div>

      <button
        type="button"
        style={{ ...styles.secondaryBtn, minWidth: 170 }}
        onClick={connectWhatsapp}
      >
        WhatsApp Bağla
      </button>
    </div>

    <label style={styles.customerBox}>
      <input
        type="checkbox"
        checked={settings.whatsapp_api_active === true}
        onChange={(e) =>
          setSettings({
            ...settings,
            whatsapp_api_active: e.target.checked,
          })
        }
      />
      <div>
        <b>WhatsApp API aktif</b>
        <div style={styles.small}>
          Firmaya ait Phone Number ID ve Access Token ile mesajları Cloud API
          üzerinden gönderir.
        </div>
      </div>
    </label>

    <Input
      label="WhatsApp Telefon Numarası"
      value={settings.whatsapp_phone_number}
      onChange={(v) =>
        setSettings({
          ...settings,
          whatsapp_phone_number: v,
        })
      }
    />

    <Input
      label="Firmaya Özel WhatsApp Phone Number ID"
      value={settings.whatsapp_phone_number_id}
      onChange={(v) =>
        setSettings({
          ...settings,
          whatsapp_phone_number_id: v,
        })
      }
    />

    <Input
      label="Firmaya Özel WhatsApp Business Account ID (WABA ID)"
      value={settings.whatsapp_business_account_id}
      onChange={(v) =>
        setSettings({
          ...settings,
          whatsapp_business_account_id: v,
        })
      }
    />

    <div>
      <Input
        label={
          settings.whatsapp_token_saved
            ? "Access Token kayıtlı; değiştirmek için yeni token gir"
            : "Firmaya Özel WhatsApp Access Token"
        }
        value={settings.whatsapp_access_token}
        onChange={(v) =>
          setSettings({
            ...settings,
            whatsapp_access_token: v,
          })
        }
      />

      {settings.whatsapp_token_saved && !settings.whatsapp_access_token && (
        <div style={styles.small}>
          Token kayıtlıdır. Güvenlik için ekranda gösterilmez.
        </div>
      )}
    </div>

    <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
      <button style={styles.primaryBtn} onClick={saveSettings}>
        Otomatik Ayarları Kaydet
      </button>

      <button style={styles.secondaryBtn} onClick={runAutomationNow}>
        Uygun Mesajları Şimdi Gönder
      </button>
    </div>
  </section>
)}


    </div>
  );
}

function StatMini({ label, value }) {
  return (
    <div style={styles.statMini}>
      <span>{label}</span>
      <b>{value}</b>
    </div>
  );
}

function Input({ label, value, onChange, type = "text" }) {
  return (
    <label style={styles.label}>
      {label}
      <input
        type={type}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        style={styles.input}
      />
    </label>
  );
}

function Textarea({ label, value, onChange }) {
  return (
    <label style={styles.label}>
      {label}
      <textarea
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        style={{ ...styles.input, minHeight: 150, resize: "vertical" }}
      />
    </label>
  );
}

function Select({ label, value, onChange, options }) {
  return (
    <label style={styles.label}>
      {label}
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        style={styles.input}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}

const styles = {
  page: {
    padding: "clamp(14px, 2vw, 26px)",
    background: "linear-gradient(180deg,#f8fafc,#eef6ff)",
    minHeight: "100vh",
    color: "#0f172a",
    fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif",
  },
  loading: {
    padding: 50,
    fontWeight: 900,
    textAlign: "center",
  },
  header: {
    background: "linear-gradient(135deg,#0f4c81,#0ea5e9,#f97316)",
    color: "#fff",
    borderRadius: 30,
    padding: "clamp(22px, 3vw, 34px)",
    marginBottom: 20,
    boxShadow: "0 22px 50px rgba(14,165,233,.25)",
    display: "flex",
    justifyContent: "space-between",
    gap: 18,
    flexWrap: "wrap",
    alignItems: "center",
  },
  headerBadge: {
    display: "inline-block",
    background: "rgba(255,255,255,.18)",
    border: "1px solid rgba(255,255,255,.35)",
    borderRadius: 999,
    padding: "6px 12px",
    fontSize: 12,
    fontWeight: 900,
    letterSpacing: 1,
    marginBottom: 12,
  },
  title: {
    margin: 0,
    fontSize: "clamp(26px, 4vw, 38px)",
    fontWeight: 950,
  },
  subtitle: {
    margin: "10px 0 0",
    opacity: 0.95,
    maxWidth: 780,
    lineHeight: 1.55,
  },
  headerStats: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
  },
  statMini: {
    minWidth: 100,
    background: "rgba(255,255,255,.16)",
    border: "1px solid rgba(255,255,255,.3)",
    borderRadius: 18,
    padding: 14,
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  tabs: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
    marginBottom: 18,
  },
  tab: {
    border: "1px solid #dbeafe",
    background: "#fff",
    color: "#1e3a8a",
    borderRadius: 14,
    padding: "11px 14px",
    fontWeight: 900,
    cursor: "pointer",
  },
  tabActive: {
    border: 0,
    background: "linear-gradient(135deg,#0ea5e9,#2563eb)",
    color: "#fff",
    borderRadius: 14,
    padding: "11px 14px",
    fontWeight: 900,
    cursor: "pointer",
    boxShadow: "0 12px 24px rgba(37,99,235,.25)",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(min(100%,390px),1fr))",
    gap: 18,
    marginBottom: 18,
  },
  card: {
    background: "rgba(255,255,255,.96)",
    borderRadius: 26,
    border: "1px solid #dbeafe",
    padding: "clamp(16px, 2vw, 24px)",
    marginBottom: 18,
    boxShadow: "0 14px 34px rgba(15,23,42,.08)",
  },
  cardTitle: {
    margin: "0 0 16px",
    fontSize: 22,
    fontWeight: 950,
    color: "#0f4c81",
  },
  sectionTitle: {
    margin: "24px 0 12px",
    paddingBottom: 8,
    borderBottom: "1px solid #dbeafe",
    fontSize: 17,
    fontWeight: 950,
    color: "#0f4c81",
  },
  label: {
    display: "flex",
    flexDirection: "column",
    gap: 7,
    fontSize: 13,
    fontWeight: 850,
    color: "#334155",
    marginBottom: 12,
  },
  input: {
    border: "1px solid #bfdbfe",
    borderRadius: 15,
    padding: "12px 13px",
    fontSize: 14,
    outline: "none",
    background: "#fff",
    width: "100%",
    boxSizing: "border-box",
  },
  two: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))",
    gap: 12,
  },
  primaryBtn: {
    border: 0,
    borderRadius: 15,
    padding: "13px 18px",
    background: "linear-gradient(135deg,#f97316,#fb923c)",
    color: "#fff",
    fontWeight: 950,
    cursor: "pointer",
    boxShadow: "0 12px 24px rgba(249,115,22,.25)",
    width: "100%",
  },
  secondaryBtn: {
    border: "1px solid #bfdbfe",
    borderRadius: 13,
    padding: "10px 13px",
    background: "#fff",
    color: "#0f4c81",
    fontWeight: 850,
    cursor: "pointer",
  },
  secondaryFull: {
    border: "1px solid #bfdbfe",
    borderRadius: 14,
    padding: "12px 13px",
    background: "#fff",
    color: "#0f4c81",
    fontWeight: 900,
    cursor: "pointer",
    width: "100%",
    marginTop: 12,
  },
  quickBox: {
    background: "#eff6ff",
    border: "1px solid #bfdbfe",
    borderRadius: 18,
    padding: 14,
    marginBottom: 12,
  },
  quickButtons: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
    marginTop: 10,
  },
  quickBtn: {
    border: 0,
    borderRadius: 999,
    padding: "9px 12px",
    background: "#dbeafe",
    color: "#1e3a8a",
    fontWeight: 850,
    cursor: "pointer",
  },
  helper: {
    background: "#fff7ed",
    border: "1px solid #fed7aa",
    color: "#9a3412",
    padding: 13,
    borderRadius: 16,
    fontSize: 13,
    fontWeight: 800,
    marginBottom: 14,
    lineHeight: 1.7,
  },
  previewPhone: {
    borderRadius: 24,
    border: "1px solid #dbeafe",
    background: "linear-gradient(180deg,#e0f2fe,#fff)",
    overflow: "hidden",
  },
  previewTop: {
    padding: 14,
    background: "linear-gradient(135deg,#0ea5e9,#2563eb)",
    color: "#fff",
    fontWeight: 950,
  },
  previewSubject: {
    padding: 14,
    borderBottom: "1px solid #dbeafe",
    background: "#fff",
  },
  previewText: {
    padding: 16,
    whiteSpace: "pre-wrap",
    fontFamily: "inherit",
    lineHeight: 1.6,
    margin: 0,
    color: "#0f172a",
  },
  rowBetween: {
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
    alignItems: "center",
    flexWrap: "wrap",
  },
  actions: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
  },
  selectedInfo: {
    background: "#fff7ed",
    color: "#9a3412",
    border: "1px solid #fed7aa",
    borderRadius: 14,
    padding: 12,
    fontWeight: 850,
    marginBottom: 12,
  },
  customerGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(min(100%,260px),1fr))",
    gap: 10,
  },
  customerBox: {
    display: "flex",
    gap: 10,
    alignItems: "flex-start",
    border: "1px solid #e5e7eb",
    borderRadius: 17,
    padding: 13,
    cursor: "pointer",
    background: "#fff",
  },
  customerBoxActive: {
    display: "flex",
    gap: 10,
    alignItems: "flex-start",
    border: "2px solid #f97316",
    borderRadius: 17,
    padding: 12,
    cursor: "pointer",
    background: "#fff7ed",
  },
  small: {
    color: "#64748b",
    fontSize: 12,
    marginTop: 3,
  },
  tableWrap: {
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: 13,
  },
  messageCell: {
    minWidth: 320,
    whiteSpace: "pre-wrap",
    lineHeight: 1.5,
  },
  whatsappBadge: {
    background: "#dcfce7",
    color: "#166534",
    padding: "6px 10px",
    borderRadius: 999,
    fontWeight: 900,
  },
  emailBadge: {
    background: "#dbeafe",
    color: "#1e40af",
    padding: "6px 10px",
    borderRadius: 999,
    fontWeight: 900,
  },
  rowBtns: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
  },
  sendBtn: {
    border: 0,
    borderRadius: 12,
    padding: "9px 12px",
    background: "#16a34a",
    color: "#fff",
    fontWeight: 900,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  copyBtn: {
    border: 0,
    borderRadius: 12,
    padding: "9px 12px",
    background: "#0ea5e9",
    color: "#fff",
    fontWeight: 900,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  deleteBtn: {
    border: 0,
    borderRadius: 12,
    padding: "9px 12px",
    background: "#dc2626",
    color: "#fff",
    fontWeight: 900,
    cursor: "pointer",
  },
  templateList: {
    display: "grid",
    gap: 12,
  },
  templateItem: {
    display: "flex",
    justifyContent: "space-between",
    gap: 14,
    alignItems: "flex-start",
    border: "1px solid #dbeafe",
    borderRadius: 18,
    padding: 15,
    background: "#f8fafc",
  },
  templatePreview: {
    margin: "8px 0 0",
    color: "#334155",
    fontSize: 13,
    lineHeight: 1.55,
    whiteSpace: "pre-wrap",
  },
  empty: {
    padding: 24,
    borderRadius: 18,
    background: "#f8fafc",
    border: "1px dashed #cbd5e1",
    color: "#64748b",
    fontWeight: 850,
    textAlign: "center",
  },
};